import React from 'react';

import './instagram.scss';

export const Instagram = ({ src }) => {
  const instagramRef = React.useRef(null);

  const embedCode = `<blockquote class="instagram-media" data-instgrm-permalink="${src}" data-instgrm-version="14" style="background: white; max-width: 600px; width: calc(100% - 2px); border-radius: 3px; border: 1px solid rgb(219, 219, 219); display: block; min-width: 325px;"></blockquote><script async src="//www.instagram.com/embed.js"></script>`;

  React.useEffect(() => {
    if (instagramRef.current) {
      instagramRef.current.innerHTML = embedCode;

      const scriptElement = document.createElement('script');
      scriptElement.async = true;
      scriptElement.async = true;
      scriptElement.src = '//www.instagram.com/embed.js';
      scriptElement.onload = () => {
        window.instgrm.Embeds.process();
      };
      instagramRef.current.appendChild(scriptElement);
    }
  }, [embedCode]);

  return <div className="bd-instagram" ref={instagramRef} />;
};
